import { createRouter, createWebHistory } from "vue-router"
import { useHead } from "@unhead/vue"
import i18n, { getBaseLocale } from "../i18n"
import routes from "./routes"

const history = createWebHistory("/")

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    if (to.hash && savedPosition) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ el: to.hash, behavior: "smooth" })
        }, 500)
      })
    } else if (to.hash) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ el: to.hash, behavior: "smooth" })
        }, 500)
      })
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { top: 0 }
    }
  },
  history: history,
  routes,
})

router.beforeEach(async (to, from, next) => {
  // Handle default locale: preserve locale from current route or default to fr-FR
  if (!to.params.locale) {
    const preservedLocale = from.params.locale || "fr-FR"
    return next({
      ...to,
      params: {
        ...to.params,       // keep slug and other params
        locale: preservedLocale,
      },
      replace: true,
    })
  }

  // Extract locale-region from route params (default to fr-FR)
  const localeRegion = to.params.locale || "fr-FR"
  
  // Extract base locale for i18n (fr-FR -> fr, en-FR -> en)
  const baseLocale = getBaseLocale(localeRegion)
  
  // Set i18n locale to base locale only
  if (baseLocale) {
    i18n.global.locale.value = baseLocale
  }

  const { title, description } = to.meta
  if (title && description) {
    useHead({
      title: i18n.global.t(`meta-tags.${title}`),
      link: [
        {
          rel: "canonical",
          href: `${import.meta.env.VITE_BASE_URL}${to.fullPath}`,
        },
      ],
      meta: [
        {
          name: "description",
          content: i18n.global.t(`meta-tags.${description}`),
        },
        {
          name: "og:title",
          content: i18n.global.t(`meta-tags.${title}`),
        },
        {
          name: "og:description",
          content: i18n.global.t(`meta-tags.${description}`),
        },
        {
          name: "og:type",
          content: "website",
        },
        {
          name: "og:image",
          content: import.meta.env.VITE_OG_IMAGES_LANDING,
        },
      ],
    })
  }
  next()
})

export default router
